import { render, staticRenderFns } from "./ImportCodas.vue?vue&type=template&id=6c577e53&scoped=true"
import script from "./ImportCodas.vue?vue&type=script&lang=js"
export * from "./ImportCodas.vue?vue&type=script&lang=js"
import style0 from "./ImportCodas.vue?vue&type=style&index=0&id=6c577e53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c577e53",
  null
  
)

export default component.exports